import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { hasPlayerPurchasedGame } from "@/services/purchasedKeysService";
import { calculateGameCoins } from "@/services/pointsService";
import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";
import { Gems } from "@/components/Gems";

interface GamePriceStatusProps {
	gameId: string;
	price: number;
	className?: string;
	size?: "sm" | "default";
}

export function GamePriceStatus({ gameId, price, className = "", size = "default" }: GamePriceStatusProps) {
	const { user } = useAuth();
	const [isPurchased, setIsPurchased] = useState(false);

	useEffect(() => {
		const checkPurchased = async () => {
			if (!user) return;

			try {
				const purchased = await hasPlayerPurchasedGame(gameId, user.id);
				setIsPurchased(purchased);
			} catch (error) {
				console.error('Error checking purchase status:', error);
				setIsPurchased(false);
			}
		};

		checkPurchased();
	}, [user?.id, gameId]);

	const textSize = size === "sm" ? "text-xs" : "text-sm";

	if (isPurchased) {
		return (
			<Badge variant="secondary" className={`bg-green-600/20 text-green-400 border-green-600/30 ${textSize} ${className}`}>
				<CheckCircle className="w-3 h-3 mr-1" />
				Already bought
			</Badge>
		);
	}

	return (
		<span className={`${textSize} text-muted-foreground flex items-center gap-1 bg-slate-700/20 py-1 px-2 rounded-full border w-fit ${className}`}>
			Cost : {calculateGameCoins(price || 0)} <Gems with_text={false} size={12} />
		</span>
	);
}

